export const messages = {
  en: {
    register: {
      title: 'Register',
      username: 'Username',
      usernameTip: 'Support combination of Chinese, letters, numbers, "-" and "_"',
      phone: 'Phone Number',
      verificationCode: 'Verification Code',
      getCode: 'Get Code',
      password: 'Password',
      passwordTip: 'Recommend using a combination of letters, numbers and symbols, 6-20 characters',
      confirmPassword: 'Confirm Password',
      agreeTerms: 'I have read and agree to',
      termsOfService: 'Terms of Service',
      privacyPolicy: 'Privacy Policy',
      registerButton: 'Register',
      loginLink: 'Login directly',
      validation: {
        usernameRequired: 'Username cannot be empty',
        usernameLength: 'Username length must be between 4 and 12 characters',
        phoneRequired: 'Phone number cannot be empty',
        phoneInvalid: 'Invalid phone number',
        codeRequired: 'Verification code cannot be empty',
        codeInvalid: 'Verification code must be numbers',
        passwordRequired: 'Password cannot be empty',
        passwordLength: 'Password length must be between 6 and 12 characters',
        termsRequired: 'Please agree to the platform agreement'
      }
    }
  },
  zh: {
    register: {
      title: '注册',
      username: '用户名',
      usernameTip: '支持中文、字母、数字、" - "" _ "的组合',
      phone: '手机号码',
      verificationCode: '验证码',
      getCode: '获取验证码',
      password: '密码',
      passwordTip: '建议使用字母、数字和符号两种及以上的组合，6-20个字符',
      confirmPassword: '确认密码',
      agreeTerms: '我已阅读并同意',
      termsOfService: '《服务条款》',
      privacyPolicy: '《隐私政策》',
      registerButton: '注册',
      loginLink: '直接登录',
      validation: {
        usernameRequired: '用户名不能为空',
        usernameLength: '用户名长度必须在4位至12位',
        phoneRequired: '手机号不能为空',
        phoneInvalid: '不是有效的手机号',
        codeRequired: '验证码不能为空',
        codeInvalid: '验证码必须是数字',
        passwordRequired: '密码不能为空',
        passwordLength: '密码长度必须在6位至12位',
        termsRequired: '请先勾选平台协议'
      }
    }
  }
}